import { lazy, Suspense, type ComponentProps } from "react";

import { LoadingSection } from "nvent-web/components/LoadingSection/LoadingSection";

const LazyApp = lazy(() =>
  import("./AuthenticatedAppAdmin").then((module) => ({
    default: module.AuthenticatedAppAdmin,
  }))
);

export const AsyncAdminApp = (props: ComponentProps<typeof LazyApp>) => (
  <Suspense fallback={<LoadingSection />}>
    <LazyApp {...props} />
  </Suspense>
);
